export const getShouldRenderTruckInventoryFeature = (
  accountTruckInventoryFeature: boolean | undefined,
  branchTruckInventoryFeature: boolean | undefined,
) => {
  return accountTruckInventoryFeature === true && branchTruckInventoryFeature === true
}
